module.exports = __webpack_public_path__ + "static/media/stau.bef124d4.svg";